import instance from './http.service';

const StabilityAiServices = {
  txt2img: (body) => {
    return instance.post('/stabilityai/txt2img', body);
  },
};
export default StabilityAiServices;
